/** @jsxImportSource @emotion/react */
import { css, Theme } from '@emotion/react'
import styled from '@emotion/styled'
import { ButtonHTMLAttributes, FC } from 'react'
import { rpMediaQueries } from '../../core/theme'
import { CloseIcon } from '../Icons'

export const StyledCloseBtn = styled.button<{
  circle?: boolean
}>`
  all: unset;

  border-radius: 77px;
  border: 1px solid rgba(255, 255, 255, 0.07);
  background: rgba(177, 22, 28, 0.3);
  box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.05), 0 3px 3px 0 rgba(0, 0, 0, 0.05),
    0 7px 7px 0 rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(7px);

  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  position: relative;

  /* Увеличенная область клика для мобильных устройств */
  &::after {
    content: '';
    position: absolute;
    top: -12px;
    left: -12px;
    right: -12px;
    bottom: -12px;
    border-radius: 50%;
  }

  &:hover {
    background: rgba(177, 22, 28, 0.5);
    border-color: rgba(255, 255, 255, 0.15);
    box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.05), 0 3px 3px 0 rgba(0, 0, 0, 0.05),
      0 7px 7px 0 rgba(0, 0, 0, 0.1), 0 0 10px 0 rgba(177, 22, 28, 0.4);
  }

  ${(props) => {
    const { circle } = props

    return circle
      ? css`
          padding: 2px;
        `
      : css`
          padding: 4px 12px;
        `
  }}

  ${rpMediaQueries.tablet} {
    ${(props) => {
      const { circle } = props

      return circle
        ? css`
            padding: 4px;
          `
        : css`
            padding: 8px 22px;
          `
    }}
  }
`

export const CloseBtn: FC<
  ButtonHTMLAttributes<HTMLButtonElement> & {
    circle?: boolean
    size?: {
      mobile: string
      tablet: string
      desktop: string
    }
    color?: keyof Theme['rpTheme']['colors']
  }
> = ({
  size = { mobile: '5px', tablet: '9px', desktop: '9px' },
  color = 'white',
  ...rest
}) => {
  return (
    <StyledCloseBtn {...rest}>
      <CloseIcon color={color} size={size} />
    </StyledCloseBtn>
  )
}
